var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app7"}},[_c('Carousel_new1',{attrs:{"vertical":false,"verticalS":false,"items":3,"rows":1,"controls":false,"texts":_vm.texts,"titles":_vm.titles,"toptitles":_vm.toptitles}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }